<template>
  <li class="step-item">
    <span class="step-number text-2xl">{{ index + 1 }}</span>
    <div class="step-content">
      <h3 class="step-title text-xl">{{ step.title }}</h3>
      <StructuredText v-if="step.text" class="structured-text description text-lg" :data="step.text" />
    </div>
  </li>
</template>

<script setup lang="ts">
import { StructuredText } from 'vue-datocms';

defineProps<{
  step: {
    title: string;
    text: string;
  };
  index: number;
}>();
</script>

<style scoped lang="scss">
.step-item {
  display: flex;
  list-style: none;

  > .step-number {
    background: var(--color-sky);
    color: var(--color-white);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    @media (--xs), (--sm), (--md) {
      width: 3rem;
      height: 3rem;
      margin-right: var(--spacing-2xs);
    }

    @media (--lg) {
      width: 3.75rem;
      height: 3.75rem;
      margin-right: var(--spacing-sm);
    }
  }
}
</style>
